module.exports = __webpack_public_path__ + "static/media/item-dropped.07295d07.gif";